import { useEffect } from "react";

// Hält --vh auf 1 % der sichtbaren Viewport-Höhe, damit mobile Browserleisten
// die Höhenberechnung von Layouts nicht verfälschen.
export function useViewportHeight() {
    useEffect(() => {
        const setVH = () => {
            const vv = (window as any).visualViewport;
            const height = vv?.height ?? window.innerHeight;
            // 1% der sichtbaren Höhe
            document.documentElement.style.setProperty("--vh", `${height * 0.01}px`);
        };
        setVH();
        window.addEventListener("resize", setVH);
        (window as any).visualViewport?.addEventListener("resize", setVH);
        return () => {
            window.removeEventListener("resize", setVH);
            (window as any).visualViewport?.removeEventListener("resize", setVH);
        };
    }, []);
}
